import { ChildrenProp } from 'shared/models/components/common.model';

export const EmptyCellContent = ({ children = '--' }: ChildrenProp) => {
  return (
    <span className="font-medium leading-4 tracking-wide test-16s text-grey-900">{children}</span>
  );
};
